/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type CreateXeroInvoiceInput = {
    invoiceId?: string | null | undefined;
    forecastClientId?: string | null | undefined;
    xeroClientId?: string | null | undefined;
    accountMap?: Array<XeroAccountLink | null> | null | undefined;
    tenantId?: string | null | undefined;
    projectInDescription?: boolean | null | undefined;
    billToId?: string | null | undefined;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type XeroAccountLink = {
    entryId?: string | null | undefined;
    accountId?: string | null | undefined;
};
export type CreateXeroInvoiceMutationVariables = {
    input: CreateXeroInvoiceInput;
};
export type CreateXeroInvoiceMutationResponse = {
    readonly createXeroInvoice: {
        readonly invoice: {
            readonly id: string;
            readonly invoiceReference: string | null;
            readonly companyInvoiceId: number | null;
            readonly name: string | null;
            readonly invoiceType: string | null;
            readonly status: string | null;
            readonly externalStatus: string | null;
            readonly dueDay: number | null;
            readonly dueMonth: number | null;
            readonly dueYear: number | null;
            readonly createdDay: number | null;
            readonly createdMonth: number | null;
            readonly createdYear: number | null;
            readonly notes: string | null;
            readonly quickbooksId: number | null;
            readonly xeroId: string | null;
            readonly xeroTenantId: string | null;
            readonly quickbooksRealmId: string | null;
            readonly economicId: number | null;
            readonly billTo: {
                readonly id: string;
                readonly name: string;
                readonly billFrom: {
                    readonly id: string;
                    readonly name: string;
                    readonly integration: string;
                } | null;
            } | null;
            readonly entries: {
                readonly edges: ReadonlyArray<{
                    readonly node: {
                        readonly id: string;
                        readonly name: string | null;
                        readonly quantity: number | null;
                        readonly unitPrice: number | null;
                        readonly discount: number | null;
                        readonly tax: number | null;
                        readonly description: string | null;
                    } | null;
                } | null> | null;
            } | null;
        } | null;
        readonly success: boolean | null;
        readonly errorMessage: string | null;
    } | null;
};
export type CreateXeroInvoiceMutation = {
    readonly response: CreateXeroInvoiceMutationResponse;
    readonly variables: CreateXeroInvoiceMutationVariables;
};



/*
mutation CreateXeroInvoiceMutation(
  $input: CreateXeroInvoiceInput!
) {
  createXeroInvoice(input: $input) {
    invoice {
      id
      invoiceReference
      companyInvoiceId
      name
      invoiceType
      status
      externalStatus
      dueDay
      dueMonth
      dueYear
      createdDay
      createdMonth
      createdYear
      notes
      quickbooksId
      xeroId
      xeroTenantId
      quickbooksRealmId
      economicId
      billTo {
        id
        name
        billFrom {
          id
          name
          integration
        }
      }
      entries(first: 100000000) {
        edges {
          node {
            id
            name
            quantity
            unitPrice
            discount
            tax
            description
          }
        }
      }
    }
    success
    errorMessage
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateXeroInvoiceInput!"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateXeroInvoicePayload",
    "kind": "LinkedField",
    "name": "createXeroInvoice",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "InvoiceType",
        "kind": "LinkedField",
        "name": "invoice",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "invoiceReference",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "companyInvoiceId",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "invoiceType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "externalStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dueDay",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dueMonth",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dueYear",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdDay",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdMonth",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "createdYear",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notes",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "quickbooksId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "xeroId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "xeroTenantId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "quickbooksRealmId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "economicId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BillTo",
            "kind": "LinkedField",
            "name": "billTo",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "BillFrom",
                "kind": "LinkedField",
                "name": "billFrom",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "integration",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 100000000
              }
            ],
            "concreteType": "InvoiceEntryTypeConnection",
            "kind": "LinkedField",
            "name": "entries",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "InvoiceEntryTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "InvoiceEntryType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "quantity",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "unitPrice",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "discount",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "tax",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "description",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "entries(first:100000000)"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errorMessage",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateXeroInvoiceMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateXeroInvoiceMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "CreateXeroInvoiceMutation",
    "operationKind": "mutation",
    "text": "mutation CreateXeroInvoiceMutation(\n  $input: CreateXeroInvoiceInput!\n) {\n  createXeroInvoice(input: $input) {\n    invoice {\n      id\n      invoiceReference\n      companyInvoiceId\n      name\n      invoiceType\n      status\n      externalStatus\n      dueDay\n      dueMonth\n      dueYear\n      createdDay\n      createdMonth\n      createdYear\n      notes\n      quickbooksId\n      xeroId\n      xeroTenantId\n      quickbooksRealmId\n      economicId\n      billTo {\n        id\n        name\n        billFrom {\n          id\n          name\n          integration\n        }\n      }\n      entries(first: 100000000) {\n        edges {\n          node {\n            id\n            name\n            quantity\n            unitPrice\n            discount\n            tax\n            description\n          }\n        }\n      }\n    }\n    success\n    errorMessage\n  }\n}\n"
  }
};
})();
(node as any).hash = '3927eb219cd90dfe89875868abbf3883';
export default node;
